module.exports = __webpack_public_path__ + "static/media/calendar-2.cd81c447.svg";